
import { computed, defineComponent } from "vue";

interface Props {
  tag: tagTypes;
  textId: string;
  options: { [key: string]: string };
  for?: string;
}

type tagTypes =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "p"
  | "span"
  | "label";

const _tagTypes = ["h1", "h2", "h3", "h4", "h5", "h6", "p", "span", "label"];

export default defineComponent({
  name: "BaseText",
  props: {
    tag: {
      type: String,
      required: true,
      default: "span",
      validator: (value: string) => _tagTypes.includes(value),
    },
    textId: {
      type: String,
      required: true,
    },
    options: {
      type: Object as () => { [key: string]: string },
      default: {},
    },
    for: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const forProp = computed(() => (props.tag === "label" ? props.for : null));
    const textClasses = computed(() => {
      return {
        "mb-2 font-bold text-lg text-grey-darkest": props.tag === "label",
      };
    });
    return {
      forProp,
      textClasses,
    };
  },
});
